module.exports = __webpack_public_path__ + "img/stand height.cea430aa.png";